import { InlineValidation } from "@nulogy/components";
import get from "lodash/get";
import React from "react";
import Form from "./Form";

function InlineErrors({ errors }) {
  const baseErrors = get(errors, "base");

  if (!baseErrors) return null;

  if (baseErrors.length === 1) {
    return <InlineValidation errorMessage={baseErrors[0]} mb="x2" />;
  }
  return <InlineValidation errorList={baseErrors} mb="x2" />;
}

export default function FormWithInlineErrors({ children, ...props }) {
  return (
    <Form ErrorsComponent={InlineErrors} {...props}>
      {children}
    </Form>
  );
}
